import styled from "@emotion/styled";

export const IconStyle = styled("div")`
  position: relative;

  .icon {
    width: 24px;
    height: 24px;
  }
`;
